import script from "./BarrierGate.vue?vue&type=script&lang=ts&setup=true"
export * from "./BarrierGate.vue?vue&type=script&lang=ts&setup=true"

import "./BarrierGate.vue?vue&type=style&index=0&id=36f18406&lang=scss"

const __exports__ = script;

export default __exports__